'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var RecommendationEntryController = function RecommendationEntryController($scope, recommendationEntryService, recommendationEntryDataService, exportToCSVService, FaresOptimizerConstants, userSecureService, faresOptimizerSharedFbcService, webFareCurveDataService, tacticalFareDefinitionService, momentService, filingFilterService, cityToPosMapper) {
  $scope.getData = function () {
    return _.get($scope, 'entry.rowGroups');
  };
  $scope.getRawData = function () {
    return _.get($scope, 'screenState.rawData');
  };
  function getSelectedItem() {
    return _.filter($scope.getData(), 'selected');
  }
  function getApproverLevel() {
    return _.get($scope, 'entry.approverType');
  }
  function isOnlyApprover() {
    return _.get($scope, 'entry.isOnlyApprover');
  }
  function getTodaysDate() {
    var momentConfig = momentService.ruleTypeToConfig('utc2date');
    return _.isUndefined(momentConfig) ? '' : momentService.systemNow(momentConfig).startOf('day');
  }
  function getSelectedPendingOrNewItems() {
    var pendingRows = _.filter($scope.getData(), {
      status: FaresOptimizerConstants.PENDING
    }) || [];
    var newRows = _.filter($scope.getData(), {
      status: FaresOptimizerConstants.NEW
    }) || [];
    var allRows = _.concat(pendingRows, newRows);
    var userSelectedRows = _.filter(allRows, 'selected');
    if (userSelectedRows.length === 0) {
      userSelectedRows = allRows;
    }
    return userSelectedRows;
  }
  function getItemsForRejection() {
    var pendingRows = _.filter($scope.getData(), {
      status: FaresOptimizerConstants.PENDING
    }) || [];
    var newRows = _.filter($scope.getData(), {
      status: FaresOptimizerConstants.NEW
    }) || [];
    var futureApprovedRows = _.filter($scope.getData(), function (row) {
      return recommendationEntryService.ladderWithApprovalDateInFuture(row);
    }) || [];
    var allRows = _.concat(pendingRows, newRows, futureApprovedRows);
    var userSelectedRows = _.filter(allRows, 'selected');
    if (userSelectedRows.length === 0) {
      userSelectedRows = allRows;
    }
    return userSelectedRows;
  }
  function getSelectedFiledOrValidatedItems() {
    var data = $scope.getData();
    var allRows = [];
    _.forEach(data, function (entry) {
      if ((entry.status === FaresOptimizerConstants.FILED || entry.status === FaresOptimizerConstants.VALIDATED) && !recommendationEntryService.isCurrentRecommendationInProcess(data, entry)) {
        allRows.push(entry);
      }
    });
    var userSelectedRows = _.filter(allRows, 'selected');
    if (userSelectedRows.length === 0) {
      userSelectedRows = allRows;
    }
    return userSelectedRows;
  }
  function getLadderIds(data) {
    return _.map(data, 'fareRecommendationRecordKey');
  }
  function getLadderIdsForApprovedLadderUpdation(data) {
    var ladderIds = _.union([data.fareRecommendationRecordKey], data.allSharedFbcLadderIds);
    return _.chain(ladderIds).filter(filterLaddersInApprovedStateWithFutureEffectiveDate).value();
  }
  function filterLaddersInApprovedStateWithFutureEffectiveDate(ladderId) {
    var ladder = _.find($scope.screenState.rawData, {
      'fareRecommendationRecordKey': ladderId
    });
    return ladder.status === 'Approved' && ladder.recommendationEffectiveDate.startOf('day').isAfter(getTodaysDate());
  }
  function getLadderDetailsForApprovedStatusDetails(data, rawData) {
    var ladderIds = getLadderIdsForApprovedLadderUpdation(data);
    return _.chain(ladderIds).map(function (ladderId) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      });
      return {
        ladderId: ladderId,
        fbc: ladder.fbc.replace(ladder.fbc.charAt(0), '*'),
        hasSharedFbc: ladder.allSharedEntryLevelFbcList.length >= 1
      };
    }).value();
  }
  $scope.setLaddersForApprovalUpdation = function (ladder) {
    $scope.laddersForApprovalUpdation = getLadderDetailsForApprovedStatusDetails(ladder, $scope.screenState.rawData);
  };
  $scope.approveButton = FaresOptimizerConstants.APPROVE_ALL;
  $scope.rejectButton = FaresOptimizerConstants.REJECT_ALL;
  $scope.undoButton = FaresOptimizerConstants.UNDO_ALL;
  $scope.approveTooltip = 'Only New and Pending Recommendations can be Approved';
  $scope.rejectTooltip = 'Only New and Pending Recommendations can be Rejected';
  if ($scope.screenState.recommendMode === 'STRUCTURAL') {
    $scope.undoTooltip = 'Only Validated Recommendations can be Undone';
    $scope.undoToastrError = 'Only Validated Recommendations can be Undone';
  } else if ($scope.screenState.recommendMode === 'TACTICAL') {
    $scope.undoTooltip = 'Only Filed and Validated Recommendations can be Undone';
    $scope.undoToastrError = 'Only Filed and Validated Recommendations can be Undone';
  }
  $scope.approveToastrError = 'Only New and Pending Recommendations can be Approved';
  $scope.rejectToastrError = 'Only New and Pending Recommendations can be Rejected';
  $scope.initController = function () {
    $scope.groupedDataCollapsed = true;
    $scope.collapseGroupsButtonLabel = $scope.getCollapseButtonLabel();
    $scope.isExpanded = true;
    $scope.detailsDisabled = false;
    $scope.createRejectModal = false;
    $scope.createApproveModal = false;
    $scope.statusDetails = {
      isOnlyApprover: isOnlyApprover(),
      approverLevel: getApproverLevel()
    };
    $scope.gridSettings.settings.maxApprovalDateRetriever = {
      getApprovalDate: recommendationEntryService.getMinimumOfTravelAndReservationDates
    };
  };
  $scope.toggleExpanded = function () {
    $scope.isExpanded = !$scope.isExpanded;
  };
  $scope.disableApproveRejectButtons = function () {
    return getApproverLevel() === undefined || !userSecureService.hasAuthorization('fares-optimizer-analysis', 'write');
  };
  $scope.toggleGroupCollapse = function () {
    $scope.groupedDataCollapsed = !$scope.groupedDataCollapsed;
    $scope.collapseGroupsButtonLabel = $scope.getCollapseButtonLabel();
    _.forEach($scope.getData(), function (group) {
      group.isCollapsed = $scope.groupedDataCollapsed;
    });
    $scope.$broadcast('simple-grid:force-refresh');
  };
  $scope.updateCollapseButtonState = function () {
    var collapsedCount = _.filter($scope.getData(), 'isCollapsed').length;
    if (collapsedCount === 0) {
      $scope.groupedDataCollapsed = false;
    }
    if (collapsedCount === $scope.getData().length) {
      $scope.groupedDataCollapsed = true;
    }
    $scope.collapseGroupsButtonLabel = $scope.getCollapseButtonLabel();
  };
  function updateDetailsLinkState() {
    var selectedItems = getSelectedItem();
    if (selectedItems) {
      $scope.selectedItem = selectedItems[0];
    } else {
      $scope.selectedItem = $scope.getData()[0];
    }
  }
  function updateButtons() {
    var selectedItems = getSelectedItem();
    var validFootnoteLadders = getLaddersWithValidFootnotes(selectedItems);
    var validProductLadders = getLaddersWithValidProducts(validFootnoteLadders);
    var approvalCount = recommendationEntryService.getApprovalCount(validProductLadders, getApproverLevel(), isOnlyApprover());
    var rejectionCount = recommendationEntryService.getRejectionCount(selectedItems, getApproverLevel(), isOnlyApprover());
    var undoCount = recommendationEntryService.getUndoCount(selectedItems, getApproverLevel(), $scope.getRawData());
    if (getApproverLevel() === undefined || selectedItems.length === 0) {
      $scope.approveButton = FaresOptimizerConstants.APPROVE_ALL;
      $scope.rejectButton = FaresOptimizerConstants.REJECT_ALL;
      $scope.undoButton = FaresOptimizerConstants.UNDO_ALL;
    } else {
      $scope.approveButton = 'Approve (' + approvalCount + ')';
      $scope.rejectButton = 'Reject (' + rejectionCount + ')';
      $scope.undoButton = 'Undo (' + undoCount + ')';
    }
  }
  function updateToolTipsAndToastrMessages() {
    if (getApproverLevel() === 'intermediate') {
      $scope.approveTooltip = 'Only New Recommendations can be Approved';
      $scope.rejectTooltip = 'Only New Recommendations can be Rejected';
      $scope.approveToastrError = 'Only New Recommendations can be Approved';
      $scope.rejectToastrError = 'Only New Recommendations can be Rejected';
    } else if (!isOnlyApprover() && getApproverLevel() === 'final') {
      $scope.approveTooltip = 'Only Pending Recommendations can be Approved';
      $scope.rejectTooltip = 'Only Pending Recommendations can be Rejected';
      $scope.approveToastrError = 'Only Pending Recommendations can be Approved';
      $scope.rejectToastrError = 'Only Pending Recommendations can be Rejected';
    } else if (getApproverLevel() === undefined) {
      $scope.approveTooltip = '';
      $scope.rejectTooltip = '';
      $scope.undoTooltip = '';
    }
  }
  $scope.selectionCallBack = function () {
    updateDetailsLinkState();
    updateButtons();
    updateToolTipsAndToastrMessages();
  };
  $scope.getCollapseButtonLabel = function () {
    return $scope.groupedDataCollapsed ? 'Expand all' : 'Collapse all';
  };
  $scope.initController();
  $scope.showDetailsOverlay = function () {
    if ($scope.selectedItem === undefined) {
      $scope.selectedItem = $scope.getData()[0];
    }
    var context = buildRecommendationDetailsContext();
    $scope.screenState.recommendationDetailsMode = 'hostView';
    $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList = [];
    $scope.screenState.recommendationDetailsPanel.chartDataAvailable = false;
    $scope.screenState.recommendationDetailsPanel.visible = true;
    $scope.screenState.recommendationDetailsPanel.contextData = context;
    getWebFareCurveData(context);
    getTacticalFareDefinitionData(context);
  };
  function buildRecommendationDetailsContext() {
    var context = _.cloneDeep($scope.selectedItem);
    context.entryLabels = $scope.entry.detailLabels;
    context.fareLaddersInGroup = $scope.entry.rowGroups;
    return context;
  }
  function getWebFareCurveData(context) {
    var cachedWebFares = _.find($scope.screenState.webFaresByKey, {
      key: buildWebFareKey(context)
    });
    if (cachedWebFares) {
      $scope.screenState.recommendationDetailsPanel.webFaresByCarrierAndFareType = cachedWebFares.webFaresByCarrierAndFareType;
      return;
    }
    var searchCriteria = buildWebFareCurveSearchCriteria(context);
    webFareCurveDataService.getWebFaresData(searchCriteria).then(function (data) {
      var webFares = _.flatten(data);
      var webFaresByCarrierAndFareType = groupWebFaresByCarrierAndFareType(webFares);
      var webFaresByKey = {
        key: buildWebFareKey(context),
        webFaresByCarrierAndFareType: webFaresByCarrierAndFareType
      };
      $scope.screenState.webFaresByKey.push(webFaresByKey);
      $scope.screenState.recommendationDetailsPanel.webFaresByCarrierAndFareType = webFaresByCarrierAndFareType;
    });
  }
  function groupWebFaresByCarrierAndFareType(webFares) {
    var webFaresByCarrierAndFareType = [];
    var webFaresByCarrier = _.groupBy(webFares, 'carrier');
    _.forEach(_.keys(webFaresByCarrier), function (carrier) {
      var webFaresByFareType = _.groupBy(webFaresByCarrier[carrier], 'tripType');
      _.forEach(_.keys(webFaresByFareType), function (fareType) {
        webFaresByCarrierAndFareType.push({
          carrier: carrier,
          fareTypeIndicator: fareType,
          webFares: webFaresByFareType[fareType]
        });
      });
    });
    return webFaresByCarrierAndFareType;
  }
  function buildWebFareCurveSearchCriteria(context) {
    return ['hostCarrier == ' + context.carrier, 'origin == ' + context.origin, 'destination == ' + context.destination, 'cabin == ' + context.cabin, 'category == ' + context.category].join(';');
  }
  function buildWebFareKey(context) {
    return [context.carrier, context.origin, context.destination, context.cabin, context.category].join('-');
  }
  function getTacticalFareDefinitionData(context) {
    var attributes = {
      carrier: context.carrier,
      origin: context.origin,
      destination: context.destination,
      cabin: context.cabin,
      originCountry: context.pos,
      destinationCountry: cityToPosMapper.getCountry(context.destination)
    };
    var cachedTacticalFareDefinition = _.find($scope.screenState.tacticalFareDefinitionDataByAttributes, {
      attributes: buildTacticalFareDefinitionKey(attributes)
    });
    if (cachedTacticalFareDefinition) {
      $scope.screenState.recommendationDetailsPanel.tacticalFareDefinitionData = cachedTacticalFareDefinition.tacticalFareDefinitionProperties;
      return;
    }
    tacticalFareDefinitionService.getTacticalFareDefinitionData(attributes).then(function (properties) {
      var tacticalFareDefinitionDataByAttributes = {
        attributes: buildTacticalFareDefinitionKey(attributes),
        tacticalFareDefinitionProperties: properties
      };
      $scope.screenState.tacticalFareDefinitionDataByAttributes.push(tacticalFareDefinitionDataByAttributes);
      $scope.screenState.recommendationDetailsPanel.tacticalFareDefinitionData = properties;
    });
  }
  function buildTacticalFareDefinitionKey(attributes) {
    return [attributes.carrier, attributes.origin, attributes.destination, attributes.originCountry, attributes.destinationCountry, attributes.cabin].join('-');
  }
  function getData(selectedItems) {
    return selectedItems.length === 0 ? $scope.getData() : selectedItems;
  }
  $scope.undoCallback = function () {
    $scope.screenState.reorderGroupOptions = false;
    recommendationEntryDataService.updateRecommendationStatus('undo', {
      authorizationNotes: $scope.stateChangeModal.authorizationNotes,
      fareRecommendationUndoKeyList: $scope.stateChangeModal.fareRecommendationUndoKeyList
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage);
  };
  $scope.undoAll = function () {
    if (!$scope.disableApproveRejectButtons()) {
      var selectedItems = getSelectedItem();
      var count = recommendationEntryService.getUndoCount(getData(selectedItems), getApproverLevel(), $scope.getRawData());
      var ladderDetailsForUndo = getLadderDetailsForUndo(getSelectedFiledOrValidatedItems(), $scope.screenState.rawData);
      if (count === 0) {
        toastr.error($scope.undoToastrError);
        if (getCancelledLadders(getSelectedFiledOrValidatedItems(), $scope.screenState.rawData)) {
          toastr.error('Non system generated Cancelled fare ladders cannot be Undone');
        }
        if (getTargetFaresCancelledLadders(getSelectedFiledOrValidatedItems(), $scope.screenState.rawData)) {
          toastr.error('Undo process not allowed as target fare ladders are discontinued');
        }
      } else {
        $scope.stateChangeModal = {
          count: count,
          fareRecommendationUndoKeyList: _.chain(ladderDetailsForUndo).map(function (entry) {
            return {
              fareRecommendationRecordKey: entry.ladderId,
              createdAt: entry.createdAt,
              status: entry.status
            };
          }).value()
        };
        $scope.showUndoModal = true;
        $scope.createUndoModal = true;
      }
    }
  };
  $scope.approveAll = function () {
    if (!$scope.disableApproveRejectButtons()) {
      var newOrPendingLadders = getSelectedPendingOrNewItems();
      var count = recommendationEntryService.getApprovalCount(newOrPendingLadders, getApproverLevel(), isOnlyApprover());
      if (count === 0) {
        toastr.error($scope.approveToastrError);
        return;
      }
      var eligibleLadders = getLaddersWithValidFootnotes(newOrPendingLadders);
      count = recommendationEntryService.getApprovalCount(eligibleLadders, getApproverLevel(), isOnlyApprover());
      if (count === 0) {
        toastr.error('Only ladders with valid Footnote dates can be Approved.');
        return;
      }
      eligibleLadders = getLaddersWithValidProducts(eligibleLadders);
      count = recommendationEntryService.getApprovalCount(eligibleLadders, getApproverLevel(), isOnlyApprover());
      if (count === 0) {
        toastr.error('Approval stopped: recommended base fare is same as current or distributed base fare.');
        return;
      }
      var recommendationLadder = recommendationEntryService.getLadderByMaxEffectiveDate(eligibleLadders);
      var maxAllowedApprovalDate = getMaximumAllowedApprovalDate(eligibleLadders);
      var sharedFbcsPresent = hasSharedFbcs(eligibleLadders);
      var ladderDetailsForApproval = faresOptimizerSharedFbcService.getLadderDetailsForApproval(eligibleLadders, $scope.screenState.rawData);
      $scope.approveModalData = {
        count: count,
        effectiveDate: recommendationLadder !== undefined ? recommendationLadder.recommendationEffectiveDate : undefined,
        maxAllowedApprovalDate: maxAllowedApprovalDate,
        authorizationNotes: recommendationLadder !== undefined ? recommendationLadder.authorizationNotes : undefined,
        hasSharedFbc: sharedFbcsPresent,
        ladderDetails: ladderDetailsForApproval,
        affectedLadderIdCount: ladderDetailsForApproval.length
      };
      $scope.showApproveModal = true;
      $scope.createApproveModal = true;
    }
  };
  function getMaximumAllowedApprovalDate(eligibleLadders) {
    return _.chain(eligibleLadders).map(getMinimumOfTravelAndReservationDates).filter(filterNotNull).min().value();
  }
  function filterNotNull(date) {
    return date !== undefined;
  }
  function getMinimumOfTravelAndReservationDates(ladder) {
    return recommendationEntryService.getMinimumOfTravelAndReservationDates(ladder);
  }
  function getLaddersWithValidFootnotes(items) {
    return _.filter(items, function (ladder) {
      return recommendationEntryService.isFootnoteDatesValid(ladder);
    });
  }
  function getLaddersWithValidProducts(items) {
    return _.filter(items, function (ladder) {
      return filingFilterService.areThereProductsForFiling(ladder);
    });
  }
  $scope.rejectAll = function () {
    if (!$scope.disableApproveRejectButtons()) {
      var selectedItems = getSelectedItem();
      var count = recommendationEntryService.getRejectionCount(selectedItems.length === 0 ? $scope.getData() : selectedItems, getApproverLevel(), isOnlyApprover());
      var ladderDetailsForRejection = getLadderDetailsForRejection(getItemsForRejection(), $scope.screenState.rawData);
      if (count === 0) {
        toastr.error($scope.rejectToastrError);
      } else {
        $scope.rejectModalData = {
          count: count,
          ladderIds: getLadderIds(getItemsForRejection()),
          entryLevelFbcs: _.chain(ladderDetailsForRejection).map('fbc').value()
        };
        $scope.showRejectModal = true;
        $scope.createRejectModal = true;
      }
    }
  };
  function getLadderDetailsForRejection(data, rawData) {
    var ladderIds = getLadderIds(getItemsForRejection());
    return _.chain(ladderIds).map(function (ladderId) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      });
      return {
        ladderId: ladderId,
        fbc: ladder.fbc.replace(ladder.fbc.charAt(0), '*')
      };
    }).value();
  }
  function getCancelledLadders(data, rawData) {
    var ladderIds = getLadderIds(data);
    return _.chain(ladderIds).filter(function (ladderId) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      });
      return ladder.allFaresCancelled;
    }).size() >= 1;
  }
  function getTargetFaresCancelledLadders(data, rawData) {
    var ladderIds = getLadderIds(data);
    return _.chain(ladderIds).filter(function (ladderId) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': ladderId
      });
      return ladder.areTargetFaresDiscontinued;
    }).size() >= 1;
  }
  function getLadderDetailsForUndo(data, rawData) {
    return _.chain(data).filter(function (entry) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': entry.fareRecommendationRecordKey,
        'createdAt': entry.createdAt,
        status: entry.status
      });
      return isLadderUndoable(ladder);
    }).map(function (entry) {
      var ladder = _.find(rawData, {
        'fareRecommendationRecordKey': entry.fareRecommendationRecordKey,
        'createdAt': entry.createdAt,
        status: entry.status
      });
      return {
        ladderId: ladder.fareRecommendationRecordKey,
        fbc: ladder.fbc.replace(ladder.fbc.charAt(0), '*'),
        createdAt: ladder.createdAt,
        status: ladder.status
      };
    }).value();
  }
  $scope.approveCallback = function () {
    $scope.screenState.reorderGroupOptions = false;
    recommendationEntryDataService.updateRecommendationStatus('approve', {
      authorizationNotes: $scope.approveModalData.authorizationNotes,
      fareRecommendationRecordKeyList: _.chain($scope.approveModalData.ladderDetails).map('ladderId').value() || [],
      effectiveTimeStamp: $scope.approveModalData.effectiveDate.format('YYYY-MM-DDTHH:mm:ss.000ZZ')
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage);
  };
  $scope.rejectCallback = function () {
    $scope.screenState.reorderGroupOptions = false;
    recommendationEntryDataService.updateRecommendationStatus('reject', {
      authorizationNotes: $scope.rejectModalData.authorizationNotes,
      rejectionExpiryDateTime: convertToUTC($scope.rejectModalData.rejectionExpiryDateTime),
      fareRecommendationRecordKeyList: $scope.rejectModalData.ladderIds || []
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage);
  };
  $scope.rejectionUpdateCallback = function () {
    $scope.screenState.reorderGroupOptions = false;
    recommendationEntryDataService.updateRecommendationStatus('reject', {
      authorizationNotes: $scope.rejectionPopUpData.authorizationNotes,
      rejectionExpiryDateTime: convertToUTC($scope.rejectionPopUpData.rejectionExpiryDateTime),
      fareRecommendationRecordKeyList: [$scope.rejectionPopUpData.fareRecommendationRecordKey]
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData, undefined, $scope.screenState.marketRawDataChunks, $scope.screenState.pager.currentPage);
  };
  $scope.updateRecommendationEffDateCallback = function () {
    getLadderIdsForApprovedLadderUpdation(_.find($scope.screenState.rawData, {
      'fareRecommendationRecordKey': $scope.statusDetails.updatedData.fareRecommendationRecordKey
    }));
    recommendationEntryDataService.updateRecommendationEffDateAndNotes({
      authorizationNotes: $scope.statusDetails.updatedData.authorizationNotes,
      fareRecommendationRecordKeyList: getLadderIdsForApprovedLadderUpdation(_.find($scope.screenState.rawData, {
        'fareRecommendationRecordKey': $scope.statusDetails.updatedData.fareRecommendationRecordKey
      })),
      effectiveTimeStamp: $scope.statusDetails.updatedData.recommendationEffectiveDate.format('YYYY-MM-DDTHH:mm:ss.000ZZ')
    }, $scope.screenState.displayedRawData, $scope.screenState.rawData);
  };
  $scope.exportToCSV = function () {
    exportToCSVService.exportToCSVFormat([$scope.entry], 'market', $scope.screenState.recommendMode);
  };
  $scope.exportSummaryToCSV = function () {
    exportToCSVService.exportToSummaryCSVFormat([$scope.entry]);
  };
  $scope.$watchCollection('entry.rowGroups', $scope.selectionCallBack);
  function hasSharedFbcs(data) {
    return faresOptimizerSharedFbcService.getSharedEntryLevelFbcs(data, $scope.screenState.rawData).length >= 1;
  }
  function isLadderUndoable(row) {
    return !_.isNil(row) && (row.status === FaresOptimizerConstants.FILED || row.status === FaresOptimizerConstants.VALIDATED) && !row.hasSharedFbc && !row.allFaresCancelled;
  }
  function convertToUTC(localDate) {
    if (localDate) {
      var dateTime = localDate.format('YYYY-MM-DDTHH:mm:ss.000ZZ');
      return momentService.of(dateTime, momentService.getConfig('DATE_TIME'), momentService.getFormat('DATE_TIME_MILLISECONDS_ISO'), undefined, true).value.format('YYYY-MM-DDTHH:mm:ss.000ZZ');
    }
    return undefined;
  }
};
RecommendationEntryController.$inject = ['$scope', 'RecommendationEntryService', 'RecommendationEntryDataService', 'FaresOptimizerCSVExportService', 'FaresOptimizerConstants', 'UserSecureService', 'FaresOptimizerSharedFbcService', 'FaresOptimizerWebFareCurveDataService', 'TacticalFareDefinitionDataService', 'MomentService', 'FaresOptimizerFilingLadderFilterService', 'CityToPosMapper'];
module.exports = RecommendationEntryController;